export const subMenuRoutes = [
  'settings',
  'analytics',
  'conversations',
  'channels',
  'ai-assistance',
  'calilio-hub',
  'tools',
] as const;
export const getRootPath = (pathname: string) => pathname.split('/')[1];
